var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiw-cards__item"},[_c('span',{staticClass:"hiw-cards__index",class:{ 'hiw-cards__index--active': _vm.isActive }},[_vm._v(_vm._s(_vm.index))]),_vm._v(" "),_c('div',{staticClass:"hiw-card"},[_vm._t("default")],2)])
}]

export { render, staticRenderFns }